import { OverlayType } from '../../constants/common'
import { EMAConfig } from './ema'

export class EMA2Config extends EMAConfig {
  static type = OverlayType.Ema2
}
